import { useMemo } from "react";
import { getLocalItem } from "../storage/LocalStorage";
import { userInfoLL, userPhotoLL } from "../storage/LocalStorageIds";
import {
  DEFAULT_PROFILE_IMAGE,
  getProfileImageFromUser,
  getUserId,
  normalizeImageSrc,
  sameUser,
} from "../utils/normalizeImageSrc";

const parseLSJson = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const useProfileImage = (userData) => {
  const profileSrc = useMemo(() => {
    const directProfileImage = getProfileImageFromUser(userData);

    if (directProfileImage) {
      return directProfileImage;
    }

    const currentUserId = getUserId(userData);
    const userInfo = getLocalItem(userInfoLL) || parseLSJson("userInfo");
    const userDataLS = parseLSJson("userData");

    if (currentUserId && sameUser(userData, userInfo)) {
      return getProfileImageFromUser(userInfo) || DEFAULT_PROFILE_IMAGE;
    }

    if (currentUserId && sameUser(userData, userDataLS)) {
      return getProfileImageFromUser(userDataLS) || DEFAULT_PROFILE_IMAGE;
    }

    if (!currentUserId) {
      return (
        normalizeImageSrc(getLocalItem(userPhotoLL)) ||
        getProfileImageFromUser(userInfo) ||
        getProfileImageFromUser(userDataLS) ||
        DEFAULT_PROFILE_IMAGE
      );
    }

    return DEFAULT_PROFILE_IMAGE;
  }, [userData]);

  return { profileSrc };
};
